import styled from "styled-components"

export const EmployeeBar = styled.div`
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 20000;
  background: var(--illiniDarkBlue);

  .user-info {
    display: flex;
    align-items: center;
  }

  .user-name {
    font-family: "Source Sans Pro";
    font-size: 1rem;
    font-weight: 700;
    color: var(--white);
    margin-right: 1rem; /* Reduced margin */
  }

  /* Toggle Switch */
  .toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px; /* Adjusted width */
    height: 24px; /* Adjusted height */
  }

  .toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 24px; /* Adjusted to match height */
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px; /* Adjusted height */
    width: 18px; /* Adjusted width */
    left: 3px; /* Adjusted to match new size */
    bottom: 3px; /* Adjusted to match new size */
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #007bff;
  }

  input:checked + .slider:before {
    transform: translateX(26px); /* Adjusted to match new width */
  }

  /* Add focus styles */
  input:focus + .slider {
    box-shadow: 0 0 1px #007bff;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
`

export const LeftInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;
`

export const RightInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50%;
  padding-right: 1rem;
`

export const NavWrapper = styled.nav`
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-weight: 700;

  margin: 0 auto;
  height: 50px;
  display: flex;
  justify-content: flex-start;

  .img{
    width:12px;
  }
  .nav-active {
    text-decoration: underline;
    color:var(--illiniDarkBlue);
  }
  ul{
    margin-left:0px;

  }
  @media (min-width: 992px) {
    font-size: 0.85rem;
    display: flex;
  }
  
  @media(max-width:991px){
    display:none;
  }

  @media (min-width: 991px) {
    font-size: 1rem;
  

  ul li {
        display: flex;
    justify-content: space-between;
    margin: 0 10px 0 0;
    float: left;
    height: 50px;
    position: relative;
    
}

button{
      border: none;
    height: 50px;
    width: 100%;
    padding-top: 10px;
    display: flex;
    appearance: none;
}
    a {
      display: flex;
    padding: 10px;
    transition: all 0.2s ease;
    height: 50px;
    border-radius: .5rem;
    }

      div {
        margin: -4px 0 0 5px;
      }
    
  }

  ul li:last-child {
    margin: 0;
  }

  ul li > ul {
    display: none;
  }

  .active{
    display:block;
    width: fit-content;
  }

  .nav-active{
    color: var(--illiniOrange)!important;
    background-color:#fff;
    text-decoraction:underline;

  }

  ul ul li a:hover{
    color: var(--illiniOrange)!important;
    text-decoraction:underline!important;
  }

  .nav{
    cursor:pointer;
  }

  ul li div img{
       margin-left: .5rem;
 }


  ul ul {
    animation: fadeInMenu 0.3s both ease-in;
    display: none;
    position: absolute;
    left: 0;
    margin: 0;
    top: 50px;
    text-transform: none;
    background: #fff;
    padding: 15px 10px 10px 10px;
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    min-width:200px;
    max-width:400px;
  }

  ul ul li {
    width: auto;
    min-width: 170px;
  }

  ul ul li a {
    padding: 5px 10px;
    white-space: nowrap;
  }
  

  @keyframes fadeInMenu {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }



     ul li a {
     color: var(--white);
    }
     ul li a:hover {
      color: var(--illiniOrange);
    }

    .nav-active {
      color: var(--illiniDarkBlue);
    }

     ul li a ul {
      background: var(--illiniDarkBlue);
    }

    ul li a ul li a {
      color: var(--white);
    }

    ul li a ul li a:hover {
      color: var(--illiniOrange);
    }

    @media (max-width: 991px) {
      display: none;
    }
}
`
